import React from 'react'

interface FormatPriceProps {
  price: string
  currency?: string
}

const FormatPrice: React.FC<FormatPriceProps> = ({ price, currency = 'USD' }) => {
  const numericPrice = Number(price)
  if (isNaN(numericPrice)) return null

  const formattedPrice = numericPrice.toLocaleString('es-AR', {
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return <span>{formattedPrice}</span>
}

export default FormatPrice
